import { useDroppable } from '@dnd-kit/core';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Badge } from '@/components/ui/badge';
import { LucideIcon } from 'lucide-react';

interface KanbanColumnProps {
  id: string;
  title: string;
  icon: LucideIcon;
  color: string;
  count: number;
  children: React.ReactNode;
}

export function KanbanColumn({ id, title, icon: Icon, color, count, children }: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      className={'flex flex-col w-72 bg-muted/30 rounded-lg border transition-colors ' + (isOver ? 'border-primary bg-primary/5' : '')}
    >
      <div className="flex items-center justify-between p-3 border-b">
        <div className="flex items-center gap-2">
          <div className={'p-1.5 rounded ' + color}>
            <Icon className="w-4 h-4 text-white" />
          </div>
          <span className="font-medium">{title}</span>
        </div>
        <Badge variant="secondary">{count}</Badge>
      </div>
      <ScrollArea className="flex-1 p-2">
        <div className="space-y-2 min-h-[200px]">
          {children}
        </div>
      </ScrollArea>
    </div>
  );
}
